import script from "./EmployersQuery.vue?vue&type=script&lang=js"
export * from "./EmployersQuery.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__